// extracted by mini-css-extract-plugin
module.exports = {"Loader":"_2f_1D1E_vryA_GS2XSw3SL","center":"_1imo0X3lROJc3NUY3tObG5"};